import { Link } from 'react-router-dom'

const PrivacyPolicyPage = () => {
  return (
    <div className='max-w-3xl mx-auto p-6 text-base text-left'>
      <h1 className='text-3xl font-bold mb-6'>Privacy Policy</h1>
      <p className='text-sm text-gray-500 mb-6'>Last updated: March 28, 2026</p>

      <p className='mb-4'>
        Inspire Health Tech ("we", "our", "us") operates the IHT Self-Service platform. This Privacy Policy explains how we collect, use, and protect your information when you use our service.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Information We Collect</h2>
      <p className='mb-4'>We collect the following types of information:</p>
      <ul className='list-disc ml-6 mb-4 space-y-1'>
        <li>Account information: email address and authentication credentials</li>
        <li>Usage data: API call logs, analytics data, and platform activity</li>
        <li>Technical data: browser type, IP address, and device information collected automatically</li>
      </ul>

      <h2 className='text-xl font-bold mt-6 mb-2'>How We Use Your Information</h2>
      <ul className='list-disc ml-6 mb-4 space-y-1'>
        <li>To provide and maintain the service</li>
        <li>To authenticate your identity and manage access</li>
        <li>To generate usage analytics and reports</li>
        <li>To communicate service updates and important notices</li>
        <li>To detect and prevent unauthorized access or misuse</li>
      </ul>

      <h2 className='text-xl font-bold mt-6 mb-2'>Data Storage and Security</h2>
      <p className='mb-4'>
        Your data is stored using Firebase services provided by Google Cloud Platform. We implement industry-standard security measures including encryption in transit and at rest, role-based access controls, and regular security reviews.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Data Sharing</h2>
      <p className='mb-4'>
        We do not sell your personal information. We may share data with third-party service providers who assist in operating our platform, subject to confidentiality obligations. We may also disclose information when required by law.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Data Retention</h2>
      <p className='mb-4'>
        We retain your information for as long as your account is active or as needed to provide services. You may request deletion of your data by contacting your account administrator.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Your Rights</h2>
      <p className='mb-4'>
        Depending on your jurisdiction, you may have the right to access, correct, or delete your personal data. To exercise these rights, contact your account administrator or reach out to us directly.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Changes to This Policy</h2>
      <p className='mb-4'>
        We may update this Privacy Policy from time to time. We will notify users of material changes by posting the updated policy on this page with a revised date.
      </p>

      <h2 className='text-xl font-bold mt-6 mb-2'>Contact Us</h2>
      <p className='mb-4'>
        If you have questions about this Privacy Policy, please contact us at <a href='mailto:support@inspireht.com' className='text-blue-6 hover:underline'>support@inspireht.com</a>.
      </p>

      <div className='mt-8 pt-4 border-t text-sm'>
        <Link to='/terms' className='text-blue-6 hover:underline'>Terms of Service</Link>
        <span className='mx-2'>·</span>
        <Link to='/' className='text-blue-6 hover:underline'>Back to Home</Link>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage
